import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { PaymentAccountGroup } from '@models/paymentAccount/model';
import { ActivePaymentAccountGroupStore } from './active-payment-account.store';

@Injectable({ providedIn: 'root' })
export class ActivePaymentAccountGroupQuery extends Query<PaymentAccountGroup> {
  protected store: ActivePaymentAccountGroupStore;

  constructor() {
    const store = inject(ActivePaymentAccountGroupStore);

    super(store);

    this.store = store;
  }
}
